import { Typography } from "@mui/material";
import * as React from "react";

export const MprcAlertNoRecordDrawer: React.FC<{message: string}> = ({ message }) => {
    return (
        <Typography
            variant="caption"
            gutterBottom
            component="div"
            color="muted"
            noWrap
            margin={1}
            paddingY={1}
            sx={
                (theme) => ({
                    marginBottom: 0
                })}
        >
            {message}
        </Typography>
    );
};
